/* src/app/shared/components/new-drawer/drawer/new-drawer.component.scss */
:host-context([dir=rtl]) .close-drawer-button {
  left: 20px;
}
:host-context([dir=ltr]) .close-drawer-button {
  right: 20px;
}
.close-drawer-button {
  position: absolute;
  cursor: pointer;
  top: 20px;
  height: 14px;
  width: 14px;
  transition: opacity 0.15s ease-out;
}
.close-drawer-button:hover {
  opacity: 0.7;
}
:host {
  display: flex;
  width: 100%;
}
.container {
  position: relative;
  z-index: 900;
  flex: 1;
}
.container__drawer {
  width: 39%;
  min-width: 420px;
}
.container__drawer ::ng-deep .mat-drawer-inner-container {
  display: flex;
  flex-direction: column;
}
.container ::ng-deep .mat-drawer-backdrop.mat-drawer-shown {
  background-color: rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 768px) {
  .container__drawer {
    width: 90%;
    min-width: unset;
  }
}
/*# sourceMappingURL=new-drawer.component.css.map */
